import { PERSIST, PERSIST_MODES } from './Persist.constants';

import { genericReducer } from '../../helpers/Redux/genericReducer';
import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';
import mergeWith from 'lodash/mergeWith';
import set from 'lodash/fp/set';
import unset from 'lodash/fp/unset';

export const initialState = {};
const isArr = Array.isArray;

const replaceAt = (state, path, payload) => set(path, payload, state);

const updateMerge = (current, patch) => {
    const base = current == null && isPlainObject(patch) ? {} : current;

    // This does not concatenate arrays or merge non-objects, just replaces
    return mergeWith({}, base, patch, (objVal, srcVal) => {
        if (isArr(objVal) && isArr(srcVal)) {
            return srcVal;
        }

        const objIsObj = isPlainObject(objVal);
        const srcIsObj = isPlainObject(srcVal);
        if (!objIsObj || !srcIsObj) {
            return srcVal;
        }

        return undefined;
    });
};

const updateAt = (state, path, payload) => {
    const current = get(state, path);
    return set(path, updateMerge(current, payload), state);
};

const deleteAt = (state, path) => unset(path, state);

export default genericReducer(initialState, {
    [PERSIST]: (state, payload, meta) => {
        const mode = meta?.mode || PERSIST_MODES.UPDATE;
        const path = meta?.path;

        if (!path) {
            return state;
        }

        switch (mode) {
            case PERSIST_MODES.REPLACE:
                return replaceAt(state, path, payload);

            case PERSIST_MODES.DELETE:
                return deleteAt(state, path);

            case PERSIST_MODES.UPDATE:
            default:
                return updateAt(state, path, payload);
        }
    },
});
